import Image from "next/image"
import Head from "next/head";
import upscbanner1 from "../../assets/images/home/Banner/UPSC-result-web-banner-2026.jpg";
// import phone from "../../assets/images/upsc/phone.png";
import downloadicon from "../../assets/images/download.png";
import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Acheiver = dynamic(()=>import("../../components/our-acheiver/achievers"));
const BranchAddress = dynamic(()=>import("../../components/branch-address"));
const ObtionalButton = dynamic(()=>import("../../components/optionalbutton"));
import Program_Features from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-program-features";
import Classroom_form from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-form";
import sadhana from "../../assets/images/upsc/sadhanaL-2.png";
import Link from "next/link";
import useDownloader from "react-use-downloader";
import Emioption from "../../components/Service/emioption";
import Optionalplus from "../../components/Service/optionalplus";
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";
const UPSCClassroomOnline = () => {
  
  const [selectedBranch, setSelectedBranch] = useState("Tamil Nadu");
  const {download} = useDownloader();
  const fileUrl = "/pdf/admission/SIA-Brochure-2025-Annanagar.pdf";
  const filename = "SIA-Brochure-2025-Annanaga.pdf"

  const feestructure =[
    {date:"16.02.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:"25.03.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:"31.03.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:(<><div>23.04.2026</div> <div><span style={{fontSize:"11px"}}>(*Subject to change<br/> based on the election date)</span></div> </>) ,  cont:"Regular",cont1:"08:00 am to 10:30 am"},
    {date:"16.05.2026", cont:"Weekend", cont1:"02:00 pm to 07:30 pm"},
    {date:"04.06.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    {date:"04.06.2026", cont:"Regular", cont1:"11:00 am to 01:30 pm"},
    {date:"24.06.2026", cont:"Regular", cont1:"11:00 am to 01:30 pm"},
    //{date:"20.07.2026", cont:"Regular", cont1:"08:00 am to 10:30 am"},
    //{date:"18.08.2026", cont:"Regular", cont1:"11:00 am to 01:30 pm"},
    

  ]

  const feestructure2 =[

    {date:"06.04.2026",cont:"Regular",cont1:"02.30 pm to 04.30 pm"},
    {date:"18.06.2026",cont:"Regular",cont1:"02.30 pm to 04.30 pm"},
    {date:"18.06.2026",cont:"Regular",cont1:"05.30 pm to 07.30 pm"},
    {date:"27.06.2026",cont:"Weekend",cont1:"09:00 am to 01:00 pm"},
   
    
  ]

  const feestructure3 =[
    {date:"04.07.2026",cont:"Weekend",cont1:"PSIR",cont2:"09:00 am to 01:00 pm"},
    {date:"04.07.2026",cont:"Weekend",cont1:"Mathematics",cont2:"08:30 am to 01:30 pm"},
    {date:"05.07.2026",cont:"Weekend",cont1:"Public Administration",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2026",cont:"Weekend",cont1:"Geography",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2026",cont:"Weekend",cont1:"Tamil literature",cont2:"09:00 am to 01:00 pm"},
    {date:"12.07.2026",cont:"Weekend",cont1:"History",cont2:"09:00 am to 01:00 pm"},
    {date:"25.07.2026",cont:"Weekend",cont1:"Psychology",cont2:"09:00 am to 01:00 pm"},
    {date:"01.08.2026",cont:"Weekend",cont1:"Economics",cont2:"09:00 am to 01:00 pm"},
    
    {date:"06.07.2026",cont:"Regular",cont1:"Anthropology",cont2:"02:30 pm to 04:30 pm"},
    {date:"20.07.2026",cont:"Regular",cont1:"Agriculture",cont2:"06:30 pm to 08:30 pm"},
    {date:"24.07.2026",cont:"Regular",cont1:"Sociology",cont2:"05:00 pm to 07:30 pm"},
    {date:"14.08.2026",cont:"Regular",cont1:"English",cont2:"02:30 pm to 05:00 pm"},
    {date:"14.09.2026",cont:"Regular",cont1:"Law",cont2:"02:30 pm to 05:00 pm"}
   
   
  ]

  const onlinelist =[
    {cont:"Shankar IAS Academy is the excellent UPSC coaching institute for civil services examination to get enrolled in various public services of the Indian Government, namely IPS (Indian Police Service), IFS (Indian Forest Service), and IAS (Indian Administrative Service)."},
    {cont:"We have an excellent crew of faculties who are experienced people and have helped plenty of students and professionals to clear the UPSC examinations at the first attempt. We provide study materials, current affairs magazines, answer composing rehearses, test series that include general studies and current affairs, infographics, essential documents, and pattern investigation as a part of the Online IAS coaching classes."},
    {cont:"We offer personalized attention who are a part of the online UPSC coaching and provide them the right feedback to get them improved."},
    {cont:"Online live classes, recorded videos, course structure of online courses, subject-wise courses, and the flexibility of choosing your preferred time, are some of the advantages that Shankar IAS Academy provide aspirants as the best online coaching academy for IAS, IPS, and UPSC."},
    {cont:"Shankar IAS Academy provides LMS access, online live classes, online class tests, E-Magazine (current affairs), online test series for both Mains and Prelims, class notes/ Study materials (Digital), and more after online live class admissions which is not available in other IAS Academies."}
  ]

  const jsonLd ={
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Best UPSC Online Coaching | Shankar IAS Academy",
    "url": "https://www.shankariasacademy.com/upsc-online-class/",
    "Image":
    "https://www.shankariasacademy.com/_next/static/media/Pre-book-2024_Webbanner-Without-button.6686241b.webp",
    "description": "Transform your aspirations into achievements with the Best UPSC Online Coaching. Expert guidance, strategic preparation, and proven results await."
  }
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      console.log(`Navigated to ${url}`);
      router.reload(); // Refresh the page on route change
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    // Cleanup on component unmount
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);

     const getBranchName = () => {
    switch (router.pathname) {
      case "/adyar":
        return "Adyar";
      case "/trichy":
        return "Trichy";
      case "/salem":
        return "Salem";
      case "/madurai":
        return "Madurai";
      case "/coimbatore":
        return "Coimbatore";
      case "/upsc-admission-anna-nagar":
        return "Tamil Nadu";
      default:
        return "Tamil Nadu";
    }
};

  const branches = [
    
    { name: "Bengaluru", path: "/bengaluru" },
    { name: "Delhi", path: "/delhi" },
    { name: "Hyderabad", path: "/hyderabad" },
    // { name: "Bhubaneswar", path: "/bhubaneswar" },
    { name: "Thiruvananthapuram", path: "/thiruvananthapuram" },
    { name: "Online Class", path: "/upsc-online-class" },
    { name: "NRI", path: "/upsc-admission-nri" },

  ];
  
    return (
      <>

        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Best UPSC Online Coaching | Shankar IAS Academy</title>
            <meta name="title" content="Best UPSC Online Coaching | Shankar IAS Academy" />
            <meta name="description" content="Transform your aspirations into achievements with the Best UPSC Online Coaching. Expert guidance, strategic preparation, and proven results await." />
            <link rel="canonical" href="https://www.shankariasacademy.com/upsc-online-class/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Best UPSC Online Coaching | Shankar IAS Academy" />
            <meta property="og:description" content="Transform your aspirations into achievements with the Best UPSC Online Coaching. Expert guidance, strategic preparation, and proven results await." />
            <meta property="og:url" content="https://www.shankariasacademy.com/upsc-online-class/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
            <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
        </Head>

      <Navbar title="upsc" />

      <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 pt-3 pt-md-4">

              {/* Desktop View */}
              <div className={`${styles.tabscrollclass} ${styles.desktopView}`}>

                <div className={styles.dropdown}>
                  <span className={styles.tamilNaduBtn}>
                    {getBranchName()}
                  </span>

                  <ul className={styles.dropdownmenu}>
                    <li><Link href="/upsc-admission-anna-nagar" className={styles.dropdownitem}>Anna Nagar</Link></li>
                    <li><Link href="/adyar" className={styles.dropdownitem}>Adyar</Link></li>
                    <li><Link href="/coimbatore" className={styles.dropdownitem}>Coimbatore</Link></li>
                    <li><Link href="/trichy" className={styles.dropdownitem}>Trichy</Link></li>
                    <li><Link href="/salem" className={styles.dropdownitem}>Salem</Link></li>
                    <li><Link href="/madurai" className={styles.dropdownitem}>Madurai</Link></li>
                  </ul>
                </div>

                {branches.map((branch) => (
                  <Link key={branch.path} href={branch.path}>
                    <button
                      className={
                        router.pathname === branch.path
                          ? styles.activeBranch
                          : styles.normalBranch
                      }
                    >
                      {branch.name}
                    </button>
                  </Link>
                ))}
              </div>

              {/* Mobile & Tablet View */}
              <div className={styles.mobileView}>

                <div className={styles.dropdown}>
                  <span className={styles.tamilNaduBtn}>
                    {getBranchName()}
                  </span>

                  <ul className={styles.dropdownmenu}>
                    <li><Link href="/upsc-admission-anna-nagar" className={styles.dropdownitem}>Anna Nagar</Link></li>
                    <li><Link href="/adyar" className={styles.dropdownitem}>Adyar</Link></li>
                    <li><Link href="/coimbatore" className={styles.dropdownitem}>Coimbatore</Link></li>
                    <li><Link href="/trichy" className={styles.dropdownitem}>Trichy</Link></li>
                    <li><Link href="/salem" className={styles.dropdownitem}>Salem</Link></li>
                    <li><Link href="/madurai" className={styles.dropdownitem}>Madurai</Link></li>
                  </ul>
                </div>

                {branches.map((branch) => (
                  <Link key={branch.path} href={branch.path}>
                    <button
                      className={
                        router.pathname === branch.path
                          ? styles.activeBranch
                          : styles.normalBranch
                      }
                    >
                      {branch.name}
                    </button>
                  </Link>
                ))}
              </div>

            </div>
          </div>
      </div>


                {/* <div className="container">
                    <div className="row">
                       <div className="col pt-3 pt-md-4">
                            <div className={`${styles.tabscrollclass} nav nav-pills align-items-baseline`}>
                                <Link href="/upsc-admission-anna-nagar"><button id={styles.tablinks} className="nav-link tab1 py-2 px-0 me-4 " type="button">Anna Nagar</button></Link>
                                <Link href="/adyar"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4 " type="button">Adyar</button></Link>
                                <Link href="/bengaluru"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Bengaluru</button></Link>
                                <Link href="/coimbatore"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Coimbatore</button></Link>
                                <Link href="/delhi"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Delhi</button></Link>
                                <Link href="/hyderabad"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Hyderabad</button></Link>
                                <Link href="/thiruvananthapuram"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Thiruvananthapuram</button></Link>
                                <Link href="/trichy"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Trichy</button></Link>
                                <Link href="/salem"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4 " type="button">Salem</button></Link>
                                <Link href="/madurai"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Madurai</button></Link>
                                <Link href="/upsc-online-class"><button id={styles.tablinks} className="nav-link tab10 py-2 px-0 me-4 active" type="button">Online Class</button></Link>
                                <Link href="/upsc-admission-nri"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">NRI</button></Link>
                            </div>
                        </div>
                    </div>
                </div> */}
               
                <div className="container">
                    <div className="row">
                        <div className="col pt-3 pt-md-4">
                            <h1 className={`${styles.pagemaintitle}`}>UPSC - Classroom & Online - Online Class</h1>
                            <Image
                                src={upscbanner1}
                                className="img-fluid w-100 pt-2"
                                alt="Classroom and online coaching"
                                title="Classroom and online coaching"
                              />
                        </div>
                    </div>
                </div>


{/* <Classroom_form branchname="Online"/> */}
<div className="container pb-5">
<div className={`${styles.coursesimg} mb-2`}>
  <div class="col-12 col-md-6 offset-md-3 mt-4">
  <p className={`${styles.contactheader} text-center`}>Enquiry</p>
  <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
  <div class={`${styles.addmissionform} npf_wgts mt-2`} data-height="550px" data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
  </div>
  </div>
</div>

 <div className="container-fluid">
        <div className={`${styles.bestbg1}`}>
          <div className="row g-4 mt-2">
            <div className="col-12 col-md-6 col-lg-12">
              <div className="card shadow-sm p-4">
                <h2> <span style={{fontSize:"20px",color:'#db1b0d' ,fontWeight:"bold"}}>Pre Booking Open</span></h2> 
                <p>
                  For pre-booking, contact the number - <span style={{color:'#db1b0d' }}>9003190030</span> 
                </p>
                <div className={`${styles.brochure} justify-content-center`}>
                <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-Chennai-Admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                     <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                    </button>
                </a>
            </div>
              </div>
            </div>   
          </div>
        </div>
      </div>

       <div className="container">
      <div className="row pt-2">

      <h2 className={`${styles.sectiontitle} pt-3`}>Course and Fees</h2>
    
        <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
        <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>General Studies</p>
            <p className={`${styles.sectionsubtitle} mx-3`}>(Preliminary Cum Mains)</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>1,38,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>

          <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>
         
      <div className="pt-3">       
        <div className="row mx-auto">
          <div className="col ps-0">
          <table className="table ">
            <tbody>
            {feestructure.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`} style={{ whiteSpace: "pre-line" }}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
              </tr>
              ))}
              <tr>
           
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>

      </div>
    

      <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
        
         <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>CSAT</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>14,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>

          <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>
          

      <div className="pt-3">       
        <div className="row mx-auto">
          <div className="col ps-0">
          <table className="table ">
            <tbody>
            {feestructure2.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
              </tr>
              ))}
            <tr>
          
            </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>

      </div>


      <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
           <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>Optional</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>34,000</span></span>
          </div>

          <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>


        <div className="pt-3" id="paymentsection">       
         <div className="row mx-auto">
          <div className="col ps-0 ps-xl-0 p-xl-0">
            <div className="table-responsive text-nowrap">
          <table className="table ">
            <tbody>
            {feestructure3.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont2}</td>
              </tr>
              ))}
              <tr>
               <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>Forestry and Geology - After Prelims Result</b></td>
              </tr>
              <tr>
             
              </tr>
            </tbody>
          </table>
          </div>
          </div>   
        </div>
      </div>
     
      </div>

      <div className="col-xl-3 offset-xl-8 col-lg-4 col-md-6 col-8  text-end pb-2 ">
        <ObtionalButton />
      </div>
      
      <div className={`${styles.facultyborder3} row p-4 h-100 mb-md-3`}>
              <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                  <p className={`${styles.sectionsubtitle} mb-0`}>GSPCM+CSAT+Optional</p>
                  <p className={`${styles.sectionsubtitle} `}>Total Amount </p>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 py-2">
                    <span className={`${styles.acheiverrank}`}> <span className={`${styles.sectionredtitle}`}><b>₹</b>1,86,000*</span><span>(inclusive of tax)</span></span>
                   
                </div>
                   
                <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2  text-right">
                   <Emioption />
                   
               </div>

                <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right pt-xl-0 pt-3">
                 <a href="https://admissionsv1.shankariasacademy.com/?center=ONLINE_CLASS&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Here</button></a>
               </div>
      </div>
    </div>
    </div>

<div className={`${styles.sadhana} `}>
<div className="container">
  <div className="row">

  {/* <div className="col-12 col-md-4 text-white mt-2 p-2">
    UPSC GS-Mains Test Series 2025 (Moksha)<br />
    <a href="/upsc-mains-test-series/" className={`${styles.normalbutton} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}> Click here <span></span></a>
  </div> */}

   <div className="col-12 offset-md-4 col-md-4 p-2">
    <Link href="/two-year-upsc-program">
      <Image alt="sadhana" className="img-fluid" src={sadhana} />
    </Link>
  </div>
  
 
 {/* <div className="col-12 col-md-4 text-white mt-2 p-2 order-first order-md-last">UPSC GSPCM 2025 (Brochure)<br />
     <button className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`} onClick={() => download(fileUrl, filename)}>
        <p className=""> <Image src={downloadicon} alt="download icon" /> Download Brochure</p>
      </button>
 </div> */}
</div>
</div>
</div>
<Program_Features />

{/* Our Acheivers */}
<div className="container">
        <div className="row">
          <div className="col pt-4 pt-md-5 text-center">
            <h2 className={`${styles.sectiontitle} mb-0`}>Our Achievers</h2>
            <p className={`${styles.sectionsubtitle}`}>
              Rank Holders from our academy
            </p>
          </div>
        </div>
      </div>

    <Acheiver />

    <section id="toppers">

<div className="container">
    <div className="row">
      <div className="  col-xl-12 col-lg-6 mb-3 mb-md-4 col-12 ">
      <Optionalplus /> 
      </div>
    </div>
  </div>
</section>

        {/* Fee Details Section */}

     

   

    {/* Location Section */}
 
      {/* <div className="container">
        <div className="row pt-3">
            <div className="col-12 col-md-6">
              <h2 className={`${styles.sectiontitle} mb-2`}>Venue</h2>
              <p className={`${styles.sectionsubtitle} mb-1`}>Shankar IAS Academy</p>
              <p className={`${styles.acheiverrank} mb-0`}>Door No 18, Old Plot No 109,</p>
              <p className={`${styles.acheiverrank} mb-0`}>New Plot No 259, AL Block, 4th Avenue,</p>
              <p className={`${styles.acheiverrank} mb-0`}>Shanthi Colony, Annanagar,</p>
              <p className={`${styles.acheiverrank}`}>Chennai 600040.</p>       
            
            <p className={`${styles.acheivername}`}><Image src={phone} alt="Shankar IAS Academy annanagar contact number" title="Contact number" className={`${styles.phoneiconcss} img-fluid pe-2`} /> <a href="tel:76677 66266" className={`${styles.numberbold}`}>76677 66266</a> <b>.</b> <a href="tel:044-66024500" className={`${styles.numberbold}`}>044-66024500</a></p>
            <a href="https://www.google.com/maps/place/Shankar+IAS+Academy/@13.0824591,80.2026201,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x9b278e8700a30d6!8m2!3d13.0824945!4d80.2048109" target="_blank"  rel="noreferrer" className={`${styles.redunderlinealink}`} style={{whiteSpace: "nowrap"}}>Get Direction</a>
            </div>

            <div className="col-12 col-md-6 pt-3 pt-md-0">
                <h2 className={`${styles.sectiontitle} mb-2`}>Venue</h2>
                  <p className={`${styles.sectionsubtitle} mb-1`}>Shankar IAS Academy</p>
                  <p className={`${styles.acheiverrank} mb-0`}>No-2/23, 3rd Cross Street,</p>
                  <p className={`${styles.acheiverrank} mb-0`}>Padmanabhanagar, Adyar,</p>
                  <p className={`${styles.acheiverrank}`}>Chennai 600020.</p>      
            
            <p className={`${styles.acheivername}`}><Image src={phone} alt="Shankar IAS academy adyar contact number" title="Contact number" className={`${styles.phoneiconcss} img-fluid pe-2`} /> <a href="tel:90252 78278" className={`${styles.numberbold}`}>90252 78278</a></p>
                <a href="https://goo.gl/maps/SMh8sACtbCwetN596" target="_blank" rel="noreferrer" className={`${styles.redunderlinealink}`} style={{whiteSpace: "nowrap"}}>Get Direction</a>
                </div>
        </div>
      </div> */}

    <div className="container">
      <div className="row pt-3">
        <div className="col">
          <h2 className={`${styles.sectiontitle} mb-0`}>Best Online UPSC Coaching – Shankar IAS Academy</h2>
          <p className={`${styles.acheiverrank} pt-md-2`}>Shankar IAS Academy, one of the best UPSC online coaching academy with professional and experienced personal coaches. More than 1500 students have passed the UPSC, IAS, and IPS exams after attending our IAS, IPS, and UPSC online classes. Now, it&apos;s your chance to clear the IAS exam that too at the first attempt by joining our online coaching for UPSC today.</p>
          <h2 className={`${styles.sectiontitle} pt-2`}>Enroll in IAS online coaching today and reach your dream of success!</h2>
          <p className={`${styles.acheiverrank} pt-md-2`}>Getting ready for the UPSC Civil services exam is very easy for those who pick the smart way of learning. Exploring the unique strategy as per the time constraints and your requirements are vital to excel in UPSC, IAS, and IPS exams.</p>
          <p className={`${styles.acheiverrank} pt-md-2`}>So what is the unique strategy that can make you excel in UPSC Civil Exams?</p>
          <p className={`${styles.acheiverrank} pt-md-2`}>Yes, you guessed it right. It&apos;s the top-rated Civil Services Online Coaching by 
          Shankar IAS Academy, which provides the best UPSC, IPS, and IAS online coaching classes videos in different languages. 
          Lockdown due to Covid-19 has changed the complete lifecycle of the humans. Most of them have started opting for 
          IAS online classes as its only option available in the lockdown. Apart from that, the UPSC online class is 
          convenient and affordable when compared to regular UPSC coaching. The class timings are also made flexible as 
          per the students&apos; availability, which is a fantastic reason why many aspirants choose online IAS coaching today.</p>
          <p className={`${styles.acheiverrank} pt-md-2`}>Shankar IAS Academy, the most preferred UPSC CSE online coaching, delivers you the updated UPSC lectures, 
          current affairs from the most reliable and competent UPSC faculty on your laptops, mobile, and other smart devices. 
          We have experienced and professionals faculties who deliver informative and short online classes for UPSC, IAS, and 
          IPS in a video format so that the aspirants can check it whenever they require relevant information about the topic.</p>
          <p className={`${styles.acheiverrank} pt-md-2`}>Homemakers and working professionals who wish to become IAS or 
          IPS will not be able to go to an academy and learn the course. Shankar IAS Academy provides online coaching 
          for IAS, IPS, and UPSC, which are the best alternative to standard IAS, IPS, and UPSC classroom program. We 
          have regular assessment and feedback system that ensures, everyone who attends the UPSC online courses have 
          access to the self-evaluation system. It can make them identify areas where they are weak and continuously 
          work on those areas to groom them well. Our faculties strive to make the aspirants of Shankar IAS Academy achieve their dream career sooner and easier.</p>  
          <h2 className={`${styles.sectiontitle} mb-0`}>Why choose Shankar IAS Academy for IAS, IPS, and UPSC Online coaching?</h2>
          {onlinelist.map((item,index)=>(
          <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`} key={index}>
                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`}  id={styles.acheiverrankspecial}>
                        <div className="d-inline">
                            <p className={`${styles.ullispan} d-inline`}>
                            {item.cont}
                            </p>
                        </div>
                    </li>      
            </ul>
            ))}
        </div>
      </div>
    </div>

      <BranchAddress />
      <Interest />
      <Footer />                        
      </>
    )
  }
  
  export default UPSCClassroomOnline;
